import { render, staticRenderFns } from "./sopspecification.vue?vue&type=template&id=9dc2821c&scoped=true"
import script from "./sopspecification.vue?vue&type=script&lang=js"
export * from "./sopspecification.vue?vue&type=script&lang=js"
import style0 from "./sopspecification.vue?vue&type=style&index=0&id=9dc2821c&prod&lang=css"
import style1 from "./sopspecification.vue?vue&type=style&index=1&id=9dc2821c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc2821c",
  null
  
)

export default component.exports